import { I18nLang } from './types';

export const resourceResolver = (language: I18nLang) =>
  import(`./locales/${language}/messages.json`);
